
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Campaign } from "@/types/campaigns";
import { useActiveStoreId } from "./useActiveStoreId";

export const useCampaignsQuery = () => {
  const { data: storeId } = useActiveStoreId();
  return useQuery({
    queryKey: ['campaigns', storeId],
    queryFn: async () => {
      // Filtro obrigatório: só mostrar campanhas da loja ativa
      if (!storeId) {
        console.log('No active store found, returning empty campaigns list');
        return [];
      }
      
      console.log('Fetching campaigns for store:', storeId);
      
      let query = supabase
        .from('campaigns')
        .select(`
          *,
          cashback_templates!campaigns_cashback_template_id_fkey (
            name,
            discount_type,
            percentage,
            multiplier,
            expiration_days
          )
        `);

      // Filtro obrigatório por store_id (a política RLS já cuida do acesso)
      query = query.eq('store_id', storeId);
      
      const { data, error } = await query.order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching campaigns:', error);
        throw error;
      }

      return data.map(campaign => ({
        ...campaign,
        product: campaign.product as "cashback" | "referral",
        status: campaign.status as "draft" | "scheduled" | "active" | "completed" | "cancelled",
        template_name: campaign.cashback_templates?.name,
        template_discount_type: campaign.cashback_templates?.discount_type,
        template_percentage: campaign.cashback_templates?.percentage,
        template_multiplier: campaign.cashback_templates?.multiplier,
        template_expiration_days: campaign.cashback_templates?.expiration_days
      })) as Campaign[];
    },
    enabled: !!storeId,
  });
};
